export enum LogType {
	Flujo = 'Flujo',
	Server = 'Server',
	Consola = 'Consola'
}
